import { IconButton, Heading, useConfirm, Text, HStack } from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { useConsortiumActions } from '../../../../store/consortium/actions';
import { hasCustomerItemSelected } from '../../../../store/consortium/selector';
import { confirmMessageProps } from '../../utils';

interface HeaderProps {
  title: string;
  onPress?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ title, onPress }) => {
  const { navigate, canGoBack } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { handleResetCustomerConsortium } = useConsortiumActions();
  const { confirm } = useConfirm();
  const isMobile = useBreakpointValue({ base: true, sm: false });

  const hasCustomerSelected = useRecoilValue(hasCustomerItemSelected);

  const goBack = () => {
    handleResetCustomerConsortium();
    navigate('Cockpit');
  };

  const handleGoBack = () => {
    if (canGoBack() && hasCustomerSelected) {
      confirm({ ...confirmMessageProps, isMobile }, goBack);
    }

    if (canGoBack() && !hasCustomerSelected) {
      goBack();
    }
  };

  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <IconButton
            testId="icon"
            icon="ArrowLeft"
            iconSize="xxs"
            p={0}
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            onPress={onPress || handleGoBack}
          />
          <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Consórcio
          </Text>
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={onPress || handleGoBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Heading testId="qa" size="h2">
          {title}
        </Heading>
      </HStack>
    </HStack>
  );
};
